<template>
	<v-dialog v-model="dialog" persistent max-width="500px">
		<file-upload-base
			ref="fileUploader"
			:id="dialogId"
			:title="title"
			:accept="accept"
			:loading="loading"
			:primary-action="primaryAction"
			:secondary-action="secondaryAction"
			:hide-title="hideTitle"
			:hide-file-accept="hideFileAccept"
			:multiple="multiple"
			@onSecondaryAction="$emit('onSecondaryAction', $event)"
			@onPrimaryAction="$emit('onPrimaryAction', $event)"
			@onFileChange="$emit('onFileChange', $event)"
			@droppedFile="$emit('droppedFile', $event)"
		/>
	</v-dialog>
</template>

<script>
	import FileUploadBase from '@components/FileUploadBase.vue';

	export default {
		components: { FileUploadBase },
		props: {
			dialogId: String,
			dialog: Boolean,
			title: String,
			accept: String,
			loading: {
				type: Boolean,
				default: false
			},
			hideTitle: {
				type: Boolean,
				default: false
			},
			hideFileAccept: {
				type: Boolean,
				default: false
			},
			secondaryAction: {
				type: String,
				default: 'Close'
			},
			primaryAction: {
				type: String,
				default: 'Submit'
			},
			multiple: {
				type: Boolean,
				default: false
			}
		},
		methods: {
			setFiles(files) {
				if (this.$refs.fileUploader) {
					this.$refs.fileUploader.files = Array.isArray(files) ? files : [files];
				}
			}
		}
	};
</script>
